module.exports = __webpack_public_path__ + "static/img/15.cbf09c49.jpg";